import React from 'react'
// components
import Grid from '@mui/material/Grid2'
import { AvatarsList } from 'components/UI'
// constants
import { REVIEW_STATUSES } from 'constants/review'
// views
import {
  AvatarWrapper,
  Button,
  ButtonLabel,
  DueDateWrapper,
  DueIndicator,
  InfoWrapper,
  InProgressIndicator,
  ProgressIndicator,
  ReviewIcon,
  TextSeparator,
  Wrapper
} from './views'
// context
import { CreateReviewBLContext } from 'containers/Review/CreateReview/layers/BL'
import { ReviewsListBLContext } from 'containers/Review/ReviewList/layers/BL'
// utils
import get from 'lodash/get'
import moment from 'moment'
//  context
import { ReviewDetailsBLContext } from 'containers/Review/ReviewDetails/layers/BL'

// types
interface IIncomingProps {
  isFullModal?: boolean
  handleOnMount?: (value: boolean) => void
}

const CompleteReview: React.FunctionComponent<IIncomingProps> = ({ isFullModal, handleOnMount }) => {
  // context
  const { review: reviewToCreate } = React.useContext(CreateReviewBLContext)
  const { handleStartReview, isSidebar } = React.useContext(ReviewsListBLContext)

  const { review, isCurrentUserReviewer, isDueToday, isOverdue, reviewers, reviewStatus } =
    React.useContext(ReviewDetailsBLContext)

  let avatarsLimit = 8

  if (isSidebar) {
    avatarsLimit = 2
  } else if (isFullModal) {
    avatarsLimit = 5
  }

  React.useEffect(() => {
    handleOnMount?.(true)

    return () => {
      handleOnMount?.(false)
    }
  }, [])

  return (
    <Wrapper $isSidebar={isSidebar} $isFullModal={isFullModal}>
      <ReviewIcon />
      <InfoWrapper container>
        <DueDateWrapper>{`Review due ${moment(review.dueDate).format('D MMM YYYY')}`}</DueDateWrapper>
        <Grid container>
          <ProgressIndicator>{reviewStatus.replace('_', ' ')}</ProgressIndicator>
          {(isDueToday || isOverdue) && (
            <>
              <TextSeparator>|</TextSeparator>
              <DueIndicator isDueToday={isDueToday}>{isDueToday ? 'DUE TODAY' : 'OVERDUE'}</DueIndicator>
            </>
          )}
        </Grid>
      </InfoWrapper>
      <AvatarWrapper container>
        <AvatarsList list={reviewers} limit={avatarsLimit} />
      </AvatarWrapper>
      {get(reviewToCreate, 'scheduledReview.id') === review.scheduledReview.id ? (
        <InProgressIndicator container alignItems={'center'}>
          IN PROGRESS
        </InProgressIndicator>
      ) : (
        isCurrentUserReviewer &&
        moment().isSameOrAfter(review.startPeriod, 'day') && (
          <Button $isFullModal={isFullModal || isSidebar} onClick={() => handleStartReview(review)}>
            <ButtonLabel>{reviewStatus === REVIEW_STATUSES.IN_PROGRESS ? 'FINISH REVIEW' : 'START REVIEW'}</ButtonLabel>
          </Button>
        )
      )}
    </Wrapper>
  )
}

export default CompleteReview
